

import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function TrendingStockModel() {
    const apiModel = ChartstwitsRepository();
    const navigate = useNavigate();
    const [initialDisplayCount, setInitialDisplayCount] = useState(100);
    const [tickersearchdata, setsearchdata] = useState({
        search: ''
    });

    const [trendingStocks, setTrendingStocks] = useState([{
        symbol: "",
        name: "",
        lastSale: 0,
        netChange: 0,
        perChange: 0,
        marketCap: "",
        country: "",
        ipoyear: "",
        volume: 0,
        sector: "",
        industry: "",
        open: [] as any,
        currency: "",
        date: "",
        high: [] as any,
        low: [] as any,
        close: [] as any
    }])

    const [filteredTrendingStocks, setFilteredTrendingStocks] = useState([{
        symbol: "",
        name: "",
        lastSale: 0,
        netChange: 0,
        perChange: 0,
        marketCap: "",
        country: "",
        ipoyear: "",
        volume: 0,
        sector: "",
        industry: "",
        open: [] as any,
        currency: "",
        date: "",
        high: [] as any,
        low: [] as any,
        close: [] as any
    }])



    const viewStocks = async () => {
        debugger;
        const responseData: any = await apiModel.getStocks();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTrendingStocks(responseData)
        }
    }

    const viewStockDetails = (d: any) => {
        const queryParams = {
            ticker: d.symbol,
        };
        const queryString = new URLSearchParams(queryParams).toString();
        navigate(`/ticker-details?${queryString}`);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        debugger;
        const searchdata = e.target.value;
        setsearchdata({ 'search': searchdata });
    }

    const sliceMainDataArray = () => {
        const slicedData = trendingStocks.slice(0, initialDisplayCount);
        setFilteredTrendingStocks(slicedData);
    };

    useEffect(() => {
        // debugger;
        if (tickersearchdata.search == '') {
            sliceMainDataArray();
        } else {
            let searchResults = trendingStocks.filter((x: any) => (x.symbol.toLowerCase().includes(tickersearchdata.search)));
            setFilteredTrendingStocks(searchResults)
        }
    }, [filteredTrendingStocks])


    useEffect(() => {
        if (tickersearchdata.search == '') {
            setInitialDisplayCount(100)
            sliceMainDataArray();
        } else {
            let searchResults = trendingStocks.filter((x: any) => (x.symbol.toLowerCase().includes(tickersearchdata.search)));
            debugger;
            setFilteredTrendingStocks(searchResults)
        }
    }, [tickersearchdata])
    


    useEffect(() => {
        viewStocks();
    }, [alert]);

    return { trendingStocks, viewStockDetails ,filteredTrendingStocks ,handleChange }

}